import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from "react";
import {
  useListContext
} from "react-admin";

const BillingGuidelinesFilters = () => {
  const CLIENT_NUMBER = 'client_number';
  const CLIENT_NAME = 'client_name';
  const searchByOptions = [
    { value: CLIENT_NUMBER, label: 'Client Number' },
    { value: CLIENT_NAME, label: 'Client Name' },
  ];
  const { setFilters, setSort } = useListContext();
  const [selectedSearchBy, setSelectedSearchBy] = useState<string>(searchByOptions[0].value);
  const [inputValue, setInputValue] = useState('');

  // Set default sort and filter
  useEffect(() => {
    setFilters({});
    setSort({ field: 'recon_billing_client_number', order: 'ASC' });
  }, []);

  // Fetching list based on filters of a partial search
  const handleApply = () => {
    if (selectedSearchBy === CLIENT_NAME) {
      setFilters({
        partial_client_name: inputValue || undefined,
      });
    }
    else if (selectedSearchBy === CLIENT_NUMBER) {
      setFilters({
        partial_client_number: inputValue || undefined,
      });
    }
  };

  const handleClear = () => {
    setInputValue('');
    setFilters({});
    setSort({ field: 'recon_billing_client_number', order: 'ASC' });
  };

  return (
    <>
      <Box>
        <Box display="flex" gap={3} px={2} py={1} alignItems="center" paddingBottom={0}>
          <TextField
            label="Partial Search"
            variant="standard"
            size="small"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />

          <FormControl variant="standard" size="small" sx={{ width: 400 }}>
            <InputLabel>Search By</InputLabel>
            <Select value={selectedSearchBy} onChange={(e) => setSelectedSearchBy(e.target.value)} label="Split Type">
              {searchByOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={handleApply}
            sx={{
              minWidth: 100,
              height: 40,
              px: 2,
              borderRadius: 2,
              fontSize: '0.85rem',
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            Apply
          </Button>
          <Button
            variant="outlined"
            onClick={handleClear}
            sx={{
              minWidth: 100,
              height: 40,
              px: 2,
              borderRadius: 2,
              fontSize: '0.85rem',
              fontWeight: 500,
              textTransform: 'none',
            }}
          >
            Clear
          </Button>
        </Box>
      </Box>
    </>
  )
}

export default BillingGuidelinesFilters;
